import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

/**
 * Multi-select filter for the Schedules page — filters by the schedule's
 * Client (workspace), matched against `schedule.workspaceId`.
 */
export const ScheduleClientFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { organizationId } = useScope();
    const { data: clients = [] } = useWorkspacesList(
        organizationId ? { organizationId } : undefined,
        { enabled: !!organizationId },
    );

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.name,
                searchableLabel: client.name,
            })),
        [clients],
    );

    const value = filters.scheduleClientIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    onChange({
                        scheduleClientIds: selected.length
                            ? selected
                            : undefined,
                    });
                }}
                name="scheduleClient"
                onBlur={noop}
            />
        </div>
    );
};
